import React from "react";
import { Drawer } from "antd";
import "./DetailsDrawer.css";

const GenericDetailsDrawer = ({
  open,
  onClose,
  title = "Details",
  data = {},
  fields = [],
  extraActions,
  emptyValue = "—",
}) => {
  return (
    <Drawer
      title={title}
      placement="right"
      onClose={onClose}
      open={open}
      closable={false}
      className="details-drawer"
      headerStyle={{ backgroundColor: '#1565c0' }}
    >
      {fields.map((field, index) => {
        const value = field.render ? field.render(data) : data?.[field.key];

        if (field.hideIfEmpty && !value) return null;

        return (
          <div key={index} className="details-drawer-row">
            <div className="details-drawer-label">
              {field.label}
            </div>

            <div className="details-drawer-value">
              {value || emptyValue}
            </div>
          </div>
        );
      })}

      {/* Custom actions (invoice / edit / etc.) */}
      {extraActions && (
        <div className="details-drawer-actions">{extraActions(data)}</div>
      )}
    </Drawer>
  );
};

export default GenericDetailsDrawer;
